import { latestEpisodes } from "@/mocks/comicData";

const tagColor: Record<string, string> = {
  日常: "bg-primary-100 text-primary-700",
  干饭: "bg-secondary-200 text-secondary-800",
  职场: "bg-accent-100 text-accent-700",
  毛孩子: "bg-primary-100 text-primary-700",
};

function Latest() {
  return (
    <section id="latest" className="container-page py-16 md:py-20">
      <div className="mb-10 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <span className="eyebrow">
            <i className="ri-refresh-line"></i>
            最新连载
          </span>
          <h2 className="section-title mt-3">丫头的快乐持续更新中</h2>
        </div>
        <p className="max-w-md text-sm leading-relaxed text-foreground-600">
          每周持续放送大黄丫头漫画最新话，轻松追更一话不落，第一时间收获新笑点。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {latestEpisodes.map((ep) => (
          <article
            key={ep.id}
            className="group flex items-center gap-4 rounded-2xl bg-background-100 p-5 transition-colors hover:bg-primary-100/70"
          >
            <div className="flex h-14 w-14 shrink-0 flex-col items-center justify-center rounded-2xl bg-primary-500 text-background-50">
              <span className="text-base font-heading leading-none">{ep.title.split("·")[0].replace("第 ", "").replace(" 话", "")}</span>
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span className={`rounded-full px-2.5 py-0.5 text-xs font-bold ${tagColor[ep.tag]}`}>
                  {ep.tag}
                </span>
                {ep.hot && (
                  <span className="flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-bold text-background-50">
                    <i className="ri-fire-fill"></i>
                    热门
                  </span>
                )}
              </div>
              <h3 className="mt-1 truncate font-heading text-base text-foreground-950 group-hover:text-primary-700">
                {ep.title}
              </h3>
              <p className="mt-0.5 truncate text-sm text-foreground-600">{ep.desc}</p>
            </div>
            <div className="shrink-0 text-right">
              <span className="text-xs font-bold text-foreground-400">{ep.date}</span>
              <div className="mt-1 flex h-8 w-8 items-center justify-center rounded-full bg-background-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50">
                <i className="ri-play-fill"></i>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Latest;